<template>
	<transition name="slide-fade">
		<div
			v-if="type && message"
			class="toast toast-top toast-center sm:toast-end mt-14 max-sm:w-full text-wrap z-40">
			<div
				:key="type"
				class="alert text-alert-text border-0 flex justify-center"
				:class="`bg-alert-${type.toLowerCase()}`">
				<span v-html="message"></span>
			</div>
		</div>
	</transition>
</template>

<script setup>
	const toastStore = useToastStore()
	const { message, type } = storeToRefs(toastStore)
</script>

<style scoped></style>
